export default {
  wrapper: {
    display: 'flex',
    padding: 10,
    backgroundColor: 'white',
    border: '1px solid #E6EAEE',
    borderRadius: 4,
    width: '100%',
    justifyContent: 'space-between',
    position: 'relative',
    '& + *': {
      marginTop: 12,
    },
  },
  columnsContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 30,
    width: '75%',
  },
  titleWrapper: {
    width: 'calc(100% - 70px)',
  },
  itemsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    '& > * + *': {
      marginLeft: 12,
    },
  },
  input: {
    border: 'none',
    borderBottom: '1px solid #4E4E4E',
    outline: 'none',
    fontSize: 20,
    width: '100%',
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  button: {
    minWidth: 23,
    minHeight: 23,
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    border: 0,
    outline: 'none',
    cursor: 'pointer',
    '&:active': {
      opacity: 0.5,
    },
  },
  buttonAdd: {
    backgroundColor: '#EE4360',
    width: 25,
    height: 25,
  },
  buttonDelete: {
    backgroundColor: '#7F8FA4',
  },
  typeIcon: {
    '& + *': {
      marginLeft: 12,
    },
  },
  typeIconCircle: {
    width: 16,
    height: 16,
    borderRadius: '50%',
    border: '1px solid #C4C4C4',
  },
  disabledBlock: {
    pointerEvents: 'none',
    opacity: 0.7,
    cursor: 'not-allowed',
  },
  hint: {
    position: 'absolute',
    fontSize: 12,
    opacity: 0.7,
    color: 'red',
  },
  checkbox: { width: 'auto', '& + *': { marginLeft: '16px !important' } },
}



// WEBPACK FOOTER //
// ./src/Components/PitchQuestionsForm/blocks/PitchQuestionItem/styles.js